import { Type } from 'class-transformer';

import { IPagination } from '@/types/utils';

export class Invite {
  id: string;
  creatorId: number;
  email: string;
  vendorAccess: {
    vendorId: number;
    companyId: number;
    accessLevel: string; // Could be "USER", "ADMIN", etc. if you have a set of valid options
  };
  companyAccess: {
    companyId: number;
    accessLevel: string; // Same note as above
  };
  status: string; // e.g. "created"
  errorMessage: string;
  dateExpires: string; // or use `Date` if you'll parse it
  dateAccepted: string; // or use `Date`
  createdAt: string; // or use `Date`
  updatedAt: string; // or use `Date`
  fullname: string;
}

export class IInviteResponse {
  @Type(() => Invite)
  result: Invite;
  details: {
    inviterName: string;
    companyName?: string;
    vendorName?: string;
  };
}

export class IInviteistResponse extends IPagination {
  @Type(() => Invite)
  results: Invite[];
}

export class INewUserAcceptPostDto {
  password: string;
  tckn: string;
  tel: string;
}
